<template>
  <footer class="info-footer">
    <nav class="footer-links">
      <a :href="TECHNICAL_DOCS_URL" target="_blank" rel="noopener">
        {{ $t("footer.technicalDocs") }}
      </a>
      <span aria-hidden="true">·</span>
      <router-link to="/guide">{{ $t("footer.userGuide") }}</router-link>
      <span aria-hidden="true">·</span>
      <a :href="REPO_URL" target="_blank" rel="noopener">
        <ion-icon :icon="logoGithub" aria-hidden="true" />
        GitHub
      </a>
      <span aria-hidden="true">·</span>
      <!-- Signed-in players get the in-app form, which files the issue for them
           and labels it. Anonymous visitors have no session to attribute a
           report to, so they keep the direct link to the issue tracker. -->
      <router-link v-if="appStore.isAuthenticated" to="/report">
        {{ $t("footer.reportProblem") }}
      </router-link>
      <a v-else :href="`${REPO_URL}/issues`" target="_blank" rel="noopener">
        {{ $t("footer.reportProblem") }}
      </a>
      <span aria-hidden="true">·</span>
      <router-link to="/legal">{{ $t("footer.legal") }}</router-link>
    </nav>
    <p class="footer-credits">
      © {{ new Date().getFullYear() }} FantasyWiki ·
      {{ $t("footer.madeBy") }}
      <a href="https://github.com/Fre0Grella" target="_blank" rel="noopener">
        Marco Galeri
      </a>
      {{ $t("footer.and") }}
      <a
        href="https://github.com/luca-patrignani"
        target="_blank"
        rel="noopener"
      >
        Luca Patrignani
      </a>
    </p>
  </footer>
</template>

<script setup lang="ts">
import { IonIcon } from "@ionic/vue";
import { logoGithub } from "ionicons/icons";
import { useAppStore } from "@/stores/app";

const REPO_URL = "https://github.com/FantasyWiki/FantasyWiki";

// The published technical documentation, built from the repository's own docs
// by `docs/site/` and deployed to GitHub Pages (docs/agents/documentation-site.md).
const TECHNICAL_DOCS_URL = "https://fantasywiki.github.io/FantasyWiki/";

const appStore = useAppStore();
</script>

<style scoped>
.info-footer {
  margin-top: 3rem;
  padding: 1.25rem 0.5rem;
  border-top: 1px solid var(--ion-border-color);
  text-align: center;
  font-size: 0.8rem;
  color: var(--ion-color-medium);
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  column-gap: 0.6rem;
  row-gap: 0.35rem;
}

.footer-links a {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  color: var(--ion-color-medium);
  text-decoration: none;
}

.footer-links a:hover {
  color: var(--ion-color-primary);
}

.footer-links ion-icon {
  font-size: 1rem;
}

.footer-credits {
  margin: 0.6rem 0 0;
  font-size: 0.75rem;
}

.footer-credits a {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.footer-credits a:hover {
  color: var(--ion-color-primary);
}
</style>
